import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // @ts-expect-error - custom class group
      "text-style": [
        {
          "text-style": [
            "compact-01",
            "compact-02",
            "compact-03",
            "compact-04",
            "compact-05",
            "compact-06",
            "compact-07",
            "title-01",
            "title-02",
            "title-03",
            "title-04",
            "title-05",
            "title-06",
            "title-07",
            "body-01",
            "body-02",
            "body-03",
            "body-04",
            "body-05",
            "body-06",
          ],
        },
      ],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => {
  return customTwMerge(clsx(inputs));
};
